import type { ReviewEntryTableRow } from '../types/reviewEntryTableRow'
import { hasClarificationBadge } from './hasClarificationBadge'
import { isToValidateStatus } from './isToValidateStatus'
import { hasThirdPartyQuestion } from './reviewEntryThirdPartyQuestion'

export interface ReviewEntriesGlobalStatus {
  needsClarificationCount: number
  newSuppliersCount: number
  toValidateCount: number
}

const getDocumentHeaderRows = (rows: ReviewEntryTableRow[]): ReviewEntryTableRow[] =>
  rows.filter((row) => row.showDocumentLevelFields)

export const getReviewEntriesGlobalStatus = (rows: ReviewEntryTableRow[]): ReviewEntriesGlobalStatus => {
  const documentRows = getDocumentHeaderRows(rows)
  let toValidateCount = 0
  let needsClarificationCount = 0
  let newSuppliersCount = 0

  for (const row of documentRows) {
    if (!isToValidateStatus(row.status)) {
      continue
    }

    toValidateCount++

    if (hasClarificationBadge(row.questions)) {
      needsClarificationCount++
    }

    if (hasThirdPartyQuestion(row.questions)) {
      newSuppliersCount++
    }
  }

  return { needsClarificationCount, newSuppliersCount, toValidateCount }
}
